import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ISeoTag, ISeoTagState } from "./seotagModel";
import {
  ActiveInactiveSeoTag,
  createSeoTag,
  deleteSeoTag,
  getAllActiveSeoTag,
  getAllSeoTag,
  getSeoTagByID,
  updateSeoTag,
} from "./services/seotag.services";

const initialState: ISeoTagState = {
  loading: false,
  error: "",
  SeoTagID: null,
  SeoTagList: [],
  SeoTagDetail: {
    PageName: "",
    PageUrl: "",
    MetaTitle: "",
    MetaKeywords: "",
    MetaDescription: "",
    IsActive: 1,
  },
};

const seotagSlice = createSlice({
  name: "seotag",
  initialState,
  reducers: {
    clearSeoTagDetails: (state) => {
      state.SeoTagDetail = initialState.SeoTagDetail;
    },
    setSeoTagID: (state, action) => {
      state.SeoTagID = action.payload;
    },
    clearSeoTagID: (state) => {
      state.SeoTagID = initialState.SeoTagID;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllSeoTag.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllSeoTag.fulfilled,
      (state, action: PayloadAction<ISeoTag[]>) => {
        state.loading = false;
        state.SeoTagList = action.payload || [];
      }
    );
    builder.addCase(getAllSeoTag.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.SeoTagList = [];
    });
    builder.addCase(createSeoTag.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(createSeoTag.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(createSeoTag.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updateSeoTag.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(updateSeoTag.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(updateSeoTag.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deleteSeoTag.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteSeoTag.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteSeoTag.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getSeoTagByID.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getSeoTagByID.fulfilled, (state, action: any) => {
      state.loading = false;
      state.SeoTagDetail = action.payload;
    });
    builder.addCase(getSeoTagByID.rejected, (state, action) => {
      state.loading = false;
      state.SeoTagDetail = initialState.SeoTagDetail;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getAllActiveSeoTag.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActiveSeoTag.fulfilled,
      (state, action: PayloadAction<ISeoTag[]>) => {
        state.loading = false;
        state.SeoTagList = action.payload || [];
      }
    );
    builder.addCase(getAllActiveSeoTag.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.SeoTagList = [];
    });
    builder.addCase(ActiveInactiveSeoTag.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(ActiveInactiveSeoTag.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(ActiveInactiveSeoTag.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const { clearSeoTagDetails, clearSeoTagID, setSeoTagID } =
  seotagSlice.actions;
export default seotagSlice.reducer;
